import script from "./ListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTable.vue?vue&type=script&setup=true&lang=js"

import "./ListTable.vue?vue&type=style&index=0&id=1eb3960f&lang=css"

const __exports__ = script;

export default __exports__